export const showRoomData = [
  {
    title: "SS26/27",
    link: "/ss26-27",
    strong: false,
    isPage: true
  },
  {
    title: "FW25/26",
    link: "/fw25-26",
    strong: false,
    isPage: true
  },
  {
    title: "SS25/26",
    link: "/ss25-26",
    strong: false,
    isPage: true
  },
  {
    title: "SHOWROOM SS 24-1",
    link: "https://my.matterport.com/show/?m=6oGtJZsNQyW",
    strong: false
  },
  {
    title: "SHOWROOM SS 24-2",
    link: "https://my.matterport.com/show/?m=BQ5fnffgAya",
    strong: false
  },
  {
    title: "SHOWROOM FW23/24-1",
    link: "https://my.matterport.com/show/?m=RELJaqqPiqD",
    strong: false
  },
  {
    title: "SHOWROOM FW23/24-2",
    link: "https://my.matterport.com/show/?m=CdU9aSdxMLc",
    strong: false
  },
  {
    title: "SHOWROOM FW23/24-2",
    link: "https://my.matterport.com/show/?m=9tfUkmrU1AR",
    strong: false
  }
]
